import { createFileRoute } from '@tanstack/react-router'
import { AerospaceGVIInspectionPage } from 'pages/aerospaceGVI/AerospaceGVIInspectionPage'

export const Route = createFileRoute('/aerospace-gvi/$inspectionId')({
  component: RouteComponent,
  staticData: {
    title: 'Aerospace GVI Inspection',
  },
})

function RouteComponent() {
  const { inspectionId } = Route.useParams()
  return <AerospaceGVIInspectionPage inspectionId={inspectionId} />
}
